import { db } from "@/fstore";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    savePayPalSubscriptionInfo({ rootState }, data) {
      // Saves the PayPal data returned during purchase event to the user doc.
      /*
      var data_example = {
        billingToken: "BA-134926900V045300H",
        facilitatorAccessToken:
          "A21AAFJrBVIhbj8GGNIwC-_nDnF5zRw-Us1Cy8z0M_HsbJDw0-6ZKaqeLtYR5YaWqv-U_WmHfAe86Ctpqdmkstv1occiboTxA",
        orderID: "9PV704487F823303D",
        subscriptionID: "I-B62YJDC1UX8L"
      };
      */

      var updated_at = new Date().getTime();
      var update = {};
      update.paypal_data_updated_at = updated_at;
      update.paypal_subscription_id = data["subscriptionID"];
      update.paypal_subscription_data_from_purchase = data;
      console.log(update);
      // Return as a promise.
      return db
        .collection("users")
        .doc(rootState.user_doc.uid)
        .update(update);

      //
    }
  }
};
